import I18N from 'i18n-js';
const I18n = window.I18n || I18N;
I18n.translations || (I18n.translations = {});
I18n.translations["en"] = I18n.extend((I18n.translations["en"] || {}), {
  "autoflow": {
    "add": "Add",
    "next": "Next",
    "operators": {
      "or": "OR"
    }
  },
  "campaign-settings": {
    "sourcing": {
      "facebook_job": {
        "save_success": "Facebook Job saved successfully"
      },
      "google": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Google Jobs saved successfully"
      },
      "landing_page": {
        "add_url": "Add a URL",
        "cancel": "Cancel",
        "custom_landing_page_description": "Generate new URLs and assign a source name per URL. Candidates who complete pre-screening on the URL will be tracked with your customized source name. Common source names are site name and assigned recruiter name, event name.",
        "custom_landing_page_title": "Customize the Landing Page Source",
        "custom_source_label": "Source Name",
        "date_created": "Date Created",
        "invalid_url": "Invalid Redirect URL",
        "landing_pages": "Landing Pages",
        "landing_pages_desc": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "redirect_after": "Redirect After",
        "redirect_url": "Redirect URL",
        "refresh_rate_min_error": "Refresh Rate must be at least 1 second",
        "reload_redirect": "Redirect/Reload",
        "save_success": "Landing page saved successfully",
        "seconds": "Seconds",
        "source_placeholder": "Ex. Washington Site",
        "source_title": "Track a custom source",
        "url_copy": "URL copied to clipboard"
      },
      "messenger": {
        "copy_url": "Copy URL",
        "create_messenger_source_url": "Create URL",
        "create_messenger_source_url_success": "Messenger URL was created successfully",
        "default_input_source_value": "Source",
        "default_select_option_value": "Select...",
        "facebook_pages": "Facebook Pages",
        "messenger_link": "Messenger Link",
        "messenger_source_url_description": "Leads that use this Messenger URL will be tracked with this source.",
        "messenger_source_url_title": "Track a custom source in Messenger URL",
        "page_title": "Facebook Page",
        "previously_created_messenger_urls": "Previously created Messenger URLs",
        "previously_created_messenger_urls_description": "Here are all the previously created Messenger URLs for this campaign.",
        "select_pages": "Select the Facebook Pages to list this campaign on Messenger, then click Save to apply your changes",
        "source_label": "Source",
        "source_title": "Track a custom source"
      },
      "tecoloco_jobs": {
        "fill_out": "Please fill out all required data on the Campaign Settings",
        "save_success": "Tecoloco Jobs saved successfully"
      }
    }
  },
  "campaigns": {
    "edit": {
      "form": {
        "job_type": "Job type",
        "job_type_options": {
          "contract": "Contract",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "location": "Location",
        "salary": "Salary"
      }
    }
  },
  "chat": {
    "bulk": {
      "actions": {
        "share": {
          "title": "Share"
        }
      }
    },
    "buttons": {
      "proceed": "Proceed",
      "submit": "Submit"
    },
    "labels": {
      "no_results": "No Data Available"
    },
    "modals": {
      "continue": "Continue"
    },
    "options": {
      "deleted": "Deleted",
      "email": "EMAIL",
      "facebook": "FACEBOOK",
      "whatsapp": "WHATS APP"
    },
    "toastr": {
      "actions": {
        "failed": "This action was not successfully processed.",
        "success": "This action was processed successfully."
      }
    },
    "upload": "Upload"
  },
  "companies": {
    "settings": {
      "buttons": {
        "delete": "Delete"
      },
      "team": {
        "role_permissions": {
          "manager": "Manager"
        }
      }
    }
  },
  "date": {
    "abbr_day_names": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ],
    "abbr_month_names": [
      null,
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "default": "%Y-%m-%d",
      "long": "%B %d, %Y",
      "short": "%b %d"
    },
    "month_names": [
      null,
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "about 1 hour",
        "other": "about %{count} hours"
      },
      "about_x_months": {
        "one": "about 1 month",
        "other": "about %{count} months"
      },
      "about_x_years": {
        "one": "about 1 year",
        "other": "about %{count} years"
      },
      "almost_x_years": {
        "one": "almost 1 year",
        "other": "almost %{count} years"
      },
      "half_a_minute": "half a minute",
      "less_than_x_minutes": {
        "one": "less than a minute",
        "other": "less than %{count} minutes"
      },
      "less_than_x_seconds": {
        "one": "less than 1 second",
        "other": "less than %{count} seconds"
      },
      "over_x_years": {
        "one": "over 1 year",
        "other": "over %{count} years"
      },
      "x_days": {
        "one": "1 day",
        "other": "%{count} days"
      },
      "x_minutes": {
        "one": "1 minute",
        "other": "%{count} minutes"
      },
      "x_months": {
        "one": "1 month",
        "other": "%{count} months"
      },
      "x_seconds": {
        "one": "1 second",
        "other": "less than %{count} seconds"
      }
    },
    "prompts": {
      "day": "Day",
      "hour": "Hour",
      "minute": "Minute",
      "month": "Month",
      "second": "Seconds",
      "year": "Year"
    }
  },
  "eos": {
    "campaign": {
      "applicant_scoring": {
        "applicant_scoring": {
          "add": "Add",
          "candidate_attribute": "Candidate Attribute",
          "description": "Select Candidate Attributes and assign a weight percentage to each one for a total ot 100% for the Applicant Score or this Campaign.",
          "dropdown_hint": "Select an Attribute from the list",
          "title": "Job Matching",
          "weight": "Weight"
        },
        "description": "Configure a Scoring System for this Campaign by assigning a weight to a Candidate Attribute (Geolocation, TalkScore English Proficiency and Multiple Choice Questions) and then setting up the scores for each item.",
        "error": "Job Matching was not saved. Please try again.",
        "item_scoring": {
          "candidate_attribute": "Candidate Attribute",
          "description": "Set up a score parameter to each of the items from 0 to 100%. In this case, a 100% means that a candidate with that particular parameter will get the full score allocated in the Job Matching tab",
          "empty": "No Candidate Attributes have been set up yet. Add Candidate Attributes and assign a weight to them first in the Job Matching tab",
          "hint": {
            "geolocation": "Distance from Campaign Location as set in the Campaign Main Settings",
            "multiple": "To edit these Items. Edit the options for this question in the Question tabs.",
            "talkScore": ""
          },
          "items": "Items and Score Parameters",
          "title": "Item Scoring",
          "value_label": {
            "geopoint": "Within"
          }
        },
        "shared": {
          "cancel": "Cancel",
          "candidate": "Candidate Attribute",
          "save": "Save"
        },
        "success": "Job Matching was saved successfully.",
        "title": "Job Matching",
        "weight_error": "Weight distribution has to add up 100%"
      },
      "label": {
        "add_button": "Add a Button",
        "add_question_set": "Add a Question Set",
        "banner": "Banner",
        "call_to_action": "Call to Action",
        "cancel": "Cancel",
        "completion_message": "Completion Message",
        "copy": "Copy",
        "create_button": "Create Button",
        "crop": "Crop",
        "facebook_pixel_id": "Facebook Pixel ID",
        "google_tag_container_id": "Google Tag Manager Container ID",
        "landing_page_type": "Landing Page Type",
        "landing_page_url": "Landing Page URL",
        "new_landing_page_design": "New Landing Page design",
        "prescreening_questions": "Prescreening Questions",
        "redirect_url": "Redirect URL",
        "text_displayed": "Text displayed"
      },
      "talkscore": {
        "weight_distribution": {
          "description": "Set up a Weight Distribution per TalkScore parameter  from 0 to 100% for this campaign. This weight Distribution will be used to calculate the Overall Score of the application and for the Job Matching System.",
          "error": "TalkScore Settings were not saved. Please try again.",
          "subtitle": "Score Parameters",
          "success": "TalkScore Settings were saved successfully.",
          "title": "TalkScore Settings"
        }
      },
      "text": {
        "active_cta_limit": "Active button count limit reached.",
        "add_cta": "Add Call to Action buttons to the Completion Screen",
        "add_cta_info": "Call to Action buttons on Landing Page completion screens to redirect applicants to your socials or to perform an action. You can create multiple buttons, but only three can be active at a time.",
        "allowed_banner_files": "Allowed file types: jpg, png, jpeg. Max %{file_size}.",
        "apply_new_design": "Apply the new landing page design to this campaign.",
        "banner_notice": "You are using the default banner for all your campaigns from Company Settings.",
        "banner_required": "Banner is required.",
        "button_limit_reached": "Button count hard limit reached",
        "click_on_dropdown": "Click on dropdown to read more about each type.",
        "custom_source_guide": "By default, the landing page is tracked as \"Landing Page\" in the source data point. You can name a landing page URL as custom source below.",
        "default_banner_use": "If no banner is added and a Default Banner is available in Company Settings, the Default Banner will be used.",
        "delete_set_confirmation": "Are you sure you want to remove this question set from this campaign?",
        "incomplete_details": "Incomplete details",
        "internal_server_error": "Sorry, we are experiencing an internal server problem. Please try again later.",
        "invalid_url": "%{url} is not a valid URL",
        "landing_page_type": {
          "multiple": {
            "description": "Questions are displayed one screen at a time.",
            "title": "One Question Per Screen"
          },
          "single": {
            "description": "All questions are displayed on a single page.",
            "title": "Long Form"
          }
        },
        "landing_pages": "Landing Pages",
        "nothing_to_update": "Nothing to update.",
        "page_type_notice": "You have already selected a %{type} type for all your campaigns from Company Settings.",
        "question_set_consistency": "By using a Question Set, you can ensure consistency across multiple Campaigns. To edit them, go to the Question Set tab in Templates.",
        "recommended_banner": "%{width}px x %{height}px recommended.",
        "response_resubmit": {
          "disabled": "Disable the back button to prevent resubmissions (Not applicable to Onboarding campaigns)",
          "enabled": "Enable the back button to allow resubmissions (Not applicable to Onboarding campaigns)"
        },
        "select_question_set": "Select a Question Set to add",
        "shown_end_form": "Shown at the end of the form.",
        "updated_successfully": "Updated successfully.",
        "view_selected_set_info": "View the Selected Question Set, remove it from this Campaign or replace it by another existing set. To edit the questions directly, go to the Question Set Templates tab."
      }
    },
    "company": {
      "label": {
        "color_theme": "Color theme",
        "default_banner": "Default Banner",
        "landing_page_sop_up_screen": "Landing Page Pop-up Screen",
        "primary": "Primary",
        "secondary": "Secondary",
        "shade": "Shade"
      },
      "listings": {
        "button": {
          "cancel": "Cancel",
          "save": "Save",
          "upload": "Upload"
        },
        "description": "This page is where your selected job application campaigns are displayed, letting candidates view your job openings and apply through their respective Landing Pages",
        "input": {
          "label": {
            "banner": "Banner",
            "banner_allowed_types": "Allowed file types: jpg, jpeg and png.",
            "banner_recommended_size": "1280px x 400px",
            "copied": "Copied to Clipboard",
            "header_char_count": "%{count}/60 characters",
            "listings_url": "Job Listing Page URL",
            "page_header": "Page Header"
          },
          "placeholder": {
            "page_header": "Search Job Openings at %{company}"
          }
        },
        "messages": {
          "error": "Settings were not saved. Please try again.",
          "success": "Settings were saved successfully."
        },
        "page": {
          "button": {
            "apply": "Apply",
            "first": "First",
            "last": "Last",
            "search": "SEARCH"
          },
          "input": {
            "keywords": "Keywords",
            "location": "Location",
            "remote": "Remote"
          },
          "label": {
            "default_header": "Search Job Openings at %{company}",
            "go_to_top": "Go to the top",
            "job_count": "Displaying %{count} of %{total} jobs",
            "no_results": "No Results",
            "salary_undisclosed": "Undisclosed"
          },
          "source": "Job Listing Page"
        },
        "title": "Job Listing Page"
      },
      "text": {
        "apply_new_design": "Apply the new landing page design to all campaigns.",
        "apply_page_type": "Apply the Landing Page Type to all Campaigns. If selected, option will be disabled in Campaign Settings.",
        "default_banner": "If no banner is uploaded to a campaign, the Default Banner will be used.",
        "default_banner_use": "Use Default Banner across all campaigns. If selected, option will be disabled in Campaign Settings.",
        "enter_custom_color": "Alternatively, you can enter HEX code values in the Primary and Secondary text fields.",
        "landing_page_sop_up_screen": "This will be displayed as a pop-up in the Landing Pages before candidates input their information.",
        "select_color_palette": "Select colors for the Landing Page color theme using the palette and sliders below."
      }
    },
    "facebook_page": {
      "record": {
        "button": {
          "disconnect": "Disconnect",
          "login": "LOG IN WITH FACEBOOK",
          "renew": "Renew",
          "renew_all": "Renew All"
        },
        "label": {
          "actions": "Actions",
          "audit": {
            "system": {
              "disconnected": "Disconnected on %{date}",
              "last_renew": "Last Renewed on %{date}"
            },
            "user": {
              "disconnected": "Disconnected by %{user} on %{date}",
              "last_renew": "Last Renewed by %{user} on %{date}"
            }
          },
          "confirmation": {
            "disconnect": {
              "text": "In order to reconnect a page after it has been disconnected, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
              "title": "Disconnect Facebook Page"
            }
          },
          "create": {
            "error": "Error creating page(s). Please try again.",
            "success": "%{pages} successfully connected."
          },
          "disconnect": {
            "error": "Error updating %{page}. Please try again.",
            "success": "%{page} was successfully disconnected."
          },
          "expiresAt": "Expiration Date",
          "facebook_id": "ID",
          "lead_ads_warning": {
            "contact": "or contact Product Support for assistance.",
            "learn_more": "Learn more here",
            "learn_more_url": "https://help.talkpush.com/en/articles/8892130-renew-or-disconnect-your-facebook-page-access-from-talkpush",
            "testing_tool": "Test your Lead Ads integration.",
            "text": "You will need to have the right level of access to renew the Facebook and WhatsApp tokens. Check the list of required permissions to make sure that the bots and Lead Ads integrations will function properly.",
            "title": "Warning"
          },
          "login": {
            "error": "Log In Error"
          },
          "name": "Name",
          "no_data": "No Data",
          "renew": {
            "error": "Error updating %{page}. Please try again.",
            "success": "The access token for %{page} was successfully renewed."
          },
          "required_permissions": "Required Permissions",
          "resubscribe": {
            "error": "Error updating. Please try again.",
            "success": "The access token for %{pages} successfully renewed."
          },
          "status": "Status",
          "title": "Facebook Page Access"
        },
        "status": {
          "active": "Active",
          "expired": "Expired",
          "expiring_soon": "Expiring Soon",
          "invalid": "Invalid",
          "tooltip": {
            "active": "In order to use the dashboard features for this page, click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "expired": "This token has expired. Click on the Log in to Facebook button and follow the steps to re-authenticate it.",
            "invalid": "This token has been invalidated by Facebook due to an authentication issue. Click on the Log in to Facebook button and follow the steps to re-authenticate it."
          }
        }
      }
    },
    "guest": {
      "label": {
        "add": "Add Guest",
        "create": {
          "desc": "Configure guests in order to easily share Candidate profiles with them via Email or WhatsApp",
          "error": "An error ocurred, please try again later",
          "required_value": "Add at least one communication method to reach this Guest in order to save.",
          "success": "Guest Created Successfully",
          "title": "Create Guest"
        },
        "name": "Name",
        "new": {
          "title": "New Guest"
        },
        "no_results": "No Results",
        "phone_number": "Phone Number",
        "role": "Role",
        "search": "Search Guests",
        "update": {
          "success": "Guest Updated Successfully",
          "title": "Update Guest"
        }
      }
    },
    "landing_page": {
      "communication_channels": {
        "email": "Email",
        "errors": {
          "field_required": "%{field} required."
        },
        "messenger": "Messenger",
        "sms": "SMS",
        "text": "Besides email, what is the best way to get hold of you and update you on the next steps?",
        "whatsapp": "WhatsApp"
      },
      "consent": "This site only uses session cookies which is essential to be able to navigate the site and use its features and functionalities. No personally identifiable data is collected by session cookies.",
      "label": {
        "audio": "Audio",
        "click_download": "Click here to download",
        "continue": "Continue",
        "contract": "Contract",
        "copy_it": "Copy it",
        "email": "Email",
        "email_it": "Email it",
        "error": "Error",
        "facebook": "Facebook",
        "file_upload": "File Upload",
        "first_name": "First Name",
        "fixed_term": "Fixed Term",
        "full_time": "Full time",
        "get_started": "Get Started",
        "internship": "Internship",
        "job_type": "Job Type",
        "last_name": "Last Name",
        "location": "Location",
        "new_recording": "New Recording",
        "next": "Next",
        "no_answer": "No Answer",
        "part_time": "Part time",
        "pause": "Pause",
        "phone_number": "Phone Number",
        "picture": "Picture",
        "play": "Play",
        "play_recording": "Play Recording",
        "post_it": "Post it",
        "probationary": "Probationary",
        "proceed": "Proceed",
        "project": "Project",
        "record_now": "Record Now",
        "regular": "Regular",
        "retake_picture": "Retake Picture",
        "retry": "Retry",
        "salary": "Salary",
        "save": "Save",
        "seasonal": "Seasonal",
        "share": "Share",
        "share_it": "Share it",
        "snap_photo": "Snap Photo",
        "start_camera": "Start Camera",
        "start_recording": "Start Recording",
        "stop": "Stop",
        "stop_recording": "Stop Recording",
        "submit": "Submit",
        "take_picture": "Take a picture",
        "text": "Text",
        "tweet_it": "Tweet it",
        "undisclosed": "Undisclosed",
        "upload": "Upload",
        "upload_again": "Upload Again",
        "upload_time": "Uploading video might take a while, please wait.",
        "view_open_positions": "View Open Positions",
        "view_sample": "View Sample",
        "volunteer": "Volunteer",
        "warning": "Warning",
        "whatsapp": "WhatsApp",
        "your_progress": "Your progress"
      },
      "persistent_privacy_policy_link": {
        "click": "Click <a target=\"_b\" href=\"https://talkpush.com/privacy/\">here</a> to read their privacy policy.",
        "info": "We use a third-party service called Talkpush to help us collect the information we need to screen applicants and make recruitment decisions."
      },
      "text": {
        "about_company": "About %{company}",
        "about_our_company": "About our company",
        "application_invalid": "Invalid application",
        "camera_not_permitted": "Camera access is blocked.",
        "close_to_new_applications": "This job is no longer accepting applications. Click on the button below to view all open positions.",
        "close_warning": "In case of leaving this questionnaire before its completion, it can be completed on a later attempt, but no previously provided answer/record will be visible or editable.",
        "completion_message": "You have successfully completed and submitted your application for %{job}. Thank you!",
        "contact_channel": "What is the best way to contact me about my application?",
        "copied_succesfully": "Copied successfully",
        "dropdown_instruction": "Select an option",
        "generic_browser_error": "Unable to record media. Make sure that there is an accessible media capture device and you are using the latest and modern browser for best experience.",
        "instructions": "Instruction(s): %{text}",
        "invalid_location": "Enter a valid location.",
        "job_type_options": {
          "contract": "Contract",
          "default": "Apply to know job type",
          "fixed_term": "Fixed Term",
          "full_time": "Full time",
          "internship": "Internship",
          "part_time": "Part time",
          "probationary": "Probationary",
          "project": "Project",
          "regular": "Regular",
          "seasonal": "Seasonal",
          "volunteer": "Volunteer"
        },
        "mic_not_permitted": "Microphone access is blocked.",
        "min_max_char": "Entry should be %{min} character(s) minimum and %{max} characters maximum",
        "no_camera": "No camera available.",
        "no_media_device": "No accessible media device.",
        "no_mic": "No microphone available.",
        "no_supported_mimetype": "There are no supported MIME media type in this browser and recording quality might suffer. Try switching to another browser or device.",
        "not_supported_browser": {
          "text": "Click the three dot menu at the top right corner of the screen and open this link on your preferred browser to continue.",
          "title": "You won’t be able to complete this questionnaire in the Facebook browser."
        },
        "our_social_media": "Our Social Media",
        "play_media": {
          "answer": "played",
          "instruction": "Click play to begin, then click the 'next' button to move to the next question.",
          "local_storage_not_present": "Browser not supported"
        },
        "pop_up_privacy_policy": "By clicking Continue, you are agreeing to the <a href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider. This will automatically check the box in the form.",
        "privacy_policy": "I agree to the <a target=\"_b\" href=\"%{policy_url}\">Privacy Policy</a> of %{company} and the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_talkpush": "I agree to the <a target=\"_b\" href=\"https://talkpush.com/privacy/\">Privacy Policy</a> of the service provider.",
        "privacy_policy_url": "https://talkpush.com/privacy/",
        "processing_answers": "Please give us a moment while we process your answers.",
        "question_progress": "%{current} of %{size}",
        "rate_your_experience": "Rate your experience",
        "receive_updates": "I want to receive updates through SMS, Facebook, Messenger or Whatsapp.",
        "remote_types": {
          "fully_remote": "Fully Remote",
          "temporarily_remote": "Temporarily Remote",
          "wfh_flexible": "WFH Flexible"
        },
        "salary_types": {
          "annually": "Annually",
          "biweekly": "Biweekly",
          "daily": "Daily",
          "hourly": "Hourly",
          "monthly": "Monthly",
          "one-time": "One-time",
          "weekly": "Weekly"
        },
        "share_with_network": "Share with your network",
        "size_of_mb": "%{size} of 20mb",
        "talkscore_instructions": "Recordings should have a minimum of 30 seconds and a maximum of 1 minute. Make sure that the audio is clear and there is no background noise.",
        "thank_you": "Thank you",
        "trouble_playing_response": "Having trouble playing this response?",
        "upload": {
          "error": {
            "failed": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "max_retries": {
              "text": "You have reached the maximum number of retries for this document. Click next to continue to the next question or submit to finish this part of your process.",
              "title": "Oops! This does not look like the document we asked for."
            },
            "not_supported": "Some files cannot be uploaded",
            "partially_recognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Make sure this is the document we asked for."
            },
            "recognition_error": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, click Retry to process it again.",
              "title": "Oops! There was a problem while processing this document."
            },
            "unrecognized": {
              "text": "Please check that you sent the right document and that it is legible. We recommend saving the file as a png, jpeg or PDF. If you’ve confirmed that you uploaded the correct document, continue with the next question.",
              "title": "Oops! One of your documents does not look like the document we asked for."
            },
            "upload_error": {
              "text": "Please try again.",
              "title": "Oops! We encountered a problem while trying to upload your document."
            }
          },
          "file_invalid_type": "File format should be .jpg, .png .doc, .pdf, .xls.",
          "file_too_large": "The file size should be less than 10MB.",
          "status": {
            "failed": "Not Recognized",
            "partially_recognized": "Not Recognized",
            "processing": "Processing",
            "recognition_error": "Not Recognized",
            "recognized": "Recognized",
            "unrecognized": "Not Recognized",
            "upload_error": "Upload Error",
            "uploaded": "Uploaded"
          },
          "success": "Your document has been recognized. Click to continue with the next question."
        },
        "upload_failed": "There was an error while uploading your response. Please try again.",
        "video_limit": "The maximum video response length is 1 minute."
      }
    },
    "message": {
      "editor": {
        "controls": {
          "alignment": {
            "buttons": {
              "center": "Align Center",
              "left": "Alight Left",
              "right": "Align Right"
            }
          },
          "basic_format": {
            "bold": "Bold",
            "italic": "Italic",
            "underline": "Underline"
          },
          "call_to_action": {
            "buttons": {
              "add": "Add Button",
              "cancel": "Cancel",
              "edit": "Edit Button",
              "remove": "Remove Button",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "emoji": {
            "labels": {
              "emoji": "Emoji"
            }
          },
          "font_size": {
            "buttons": {
              "add": "Font Size"
            }
          },
          "image": {
            "buttons": {
              "add": "Add"
            },
            "labels": {
              "image": "Image",
              "paste_image_url": "Paste Image URL"
            }
          },
          "link": {
            "buttons": {
              "add": "Add Link",
              "cancel": "Cancel",
              "edit": "Edit Link",
              "remove": "Remove Link",
              "save": "Save"
            },
            "labels": {
              "link": "Link",
              "text": "Text to display",
              "token": "Select a token from the list"
            },
            "link_types": {
              "link": "Link",
              "token": "Link Token"
            }
          },
          "token": {
            "buttons": {
              "tokens": "Tokens"
            }
          }
        }
      },
      "label": {
        "delete": "Delete",
        "duplicate": "Duplicate",
        "edit": "Edit"
      },
      "template": {
        "caption": "The Template Name will help you tell the templates apart, so make it unique and identifiable.",
        "character_count": "Character left: %{count} / %{limit}",
        "create_new": "Create New",
        "description": "Configure Message Templates for all channels to be used in Autoflow, for Bulk Actions, Folder Movements and as Quick Replies in all stages of the hiring process.",
        "email": {
          "name": "Email Template Name",
          "subject_line": "Subject Line",
          "tab": "Email",
          "title": "Email Templates"
        },
        "input": {
          "search_bar": {
            "placeholder": "Search Message Templates"
          }
        },
        "messenger": {
          "name": "Messenger Template Name",
          "tab": "Messenger",
          "title": "Messenger Templates"
        },
        "sms": {
          "name": "SMS Template Name",
          "tab": "SMS",
          "title": "SMS Templates"
        },
        "text": {
          "approved_by_meta": "Approved by Meta",
          "created_by_admin": "Created by Admin",
          "created_on": "Created on %{date} by %{name}",
          "last_edited_on": "Edited on %{date} by %{name}",
          "linked_campaigns_description": "This Message Template is being used for Autoflow in the following Campaigns",
          "update_from_template": "Update Message from Template",
          "update_from_template_confirmation": "This message is currently linked to a Message Template. If you edit it, it will be unlinked from the Template and any other changes will have to be done manually to this Autoflow action as any bulk edits to the Template will no longer be applied to it.",
          "update_template": "Update Message Template",
          "update_template_confirmation": "By updating this Message Template, all Autoflow actions using it will be updated as well. Do you want to proceed?"
        },
        "title": "Message Templates",
        "whatsapp": {
          "name": "WhatsApp Template Name",
          "tab": "WhatsApp",
          "title": "WhatsApp Templates"
        }
      },
      "tokens": {
        "aspiring_minds_assessment_link": {
          "description": "Personalized link to Aspiring Minds assessment",
          "title": "Aspiring Minds assessment link"
        },
        "aspiring_minds_login_link": {
          "description": "Personalized link to Aspiring Minds login",
          "title": "Aspiring Minds login link"
        },
        "aspiring_minds_password": {
          "description": "Aspiring Minds password",
          "title": "Aspiring Minds password"
        },
        "aspiring_minds_svar_url": {
          "description": "Personalized link to Aspiring Minds SVAR assessment",
          "title": "Aspiring Minds SVAR assessment link"
        },
        "aspiring_minds_username": {
          "description": "Aspiring Minds username",
          "title": "Aspiring Minds username"
        },
        "assigned_recruiter": {
          "description": "Full name of the assigned recruiter",
          "title": "Assigned Recruiter"
        },
        "assigned_recruiter_calendar_scheduler_url": {
          "description": "Link to the assigned manager's calendar scheduler",
          "title": "Assigned Recruiter Calendar Scheduler URL"
        },
        "button": {
          "name": "Tokens"
        },
        "calendar_date": {
          "description": "My Calendar appointment date",
          "title": "Calendar Date"
        },
        "calendar_time_end": {
          "description": "My Calendar appointment time end",
          "title": "Calendar Time End"
        },
        "calendar_time_start": {
          "description": "My Calendar appointment time start",
          "title": "Calendar Time Start"
        },
        "call_center_agent_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent assessment",
          "title": "SHL Call Center Agent Assessment URL"
        },
        "call_center_agent_secondary_assessment_url": {
          "description": "Personalized link to SHL Call Center Agent Secondary assessment",
          "title": "SHL Call Center Agent Secondary Assessment URL"
        },
        "candidate_first_name": {
          "description": "Candidate's first name",
          "title": "Candidate First Name"
        },
        "candidate_id": {
          "description": "Candidate's application ID",
          "title": "Candidate ID"
        },
        "candidate_name": {
          "description": "Candidate's full name",
          "title": "Candidate Name"
        },
        "channel_optin_url": {
          "description": "Link to WhatsApp Opt-In page",
          "title": "WhatsApp Opt-in URL"
        },
        "chat_attachment": {
          "description": "Personalized chat ID to request files by Messenger",
          "title": "Chat Attachment"
        },
        "choose_position_link": {
          "description": "Personalized link to show job cards on Messenger",
          "title": "Choose Position Link"
        },
        "city": {
          "description": "Campaign's job location",
          "title": "Campaign City"
        },
        "company": {
          "description": "Name of your company",
          "title": "Company"
        },
        "emmersion_sign_in_url": {
          "description": "Sign In link to Emmersion assessments",
          "title": "Emmersion Link"
        },
        "hireiq_assessment_link": {
          "description": "Personalized link to Hire IQ assessment",
          "title": "Hire IQ Link"
        },
        "hireiq_pin": {
          "description": "Hire IQ PIN number",
          "title": "Hire IQ PIN"
        },
        "insert_picture": {
          "description": "Insert an image to be sent via email or Messenger",
          "title": "Insert Picture"
        },
        "insert_video": {
          "description": "Insert an video to be sent via email or Messenger",
          "title": "Insert Video"
        },
        "interview_page_url": {
          "description": "Personalized link to the landing page form",
          "title": "Interview Link"
        },
        "job_landing_page_url": {
          "description": "Link to the job description page",
          "title": "Job Landing Page URL"
        },
        "job_title": {
          "description": "Job the candidate applied for",
          "title": "Job Title"
        },
        "mail_attachment": {
          "description": "Personalized email ID to request files by email",
          "title": "Mail Attachment"
        },
        "messenger_call_to_action_link": {
          "description": "Messenger Call To Action Link",
          "title": "Messenger Call To Action Link"
        },
        "messenger_interview_link": {
          "description": "Personalized link to trigger interview questions on Messenger",
          "title": "Messenger Interview Link"
        },
        "my_calendar_scheduler_url": {
          "description": "Link to your calendar scheduler",
          "title": "My Calendar Scheduler URL"
        },
        "onboarding_form_url": {
          "description": "Link to the onboarding online form",
          "title": "Onboarding Form URL"
        },
        "onboarding_link": {
          "description": "Link to the onboarding chatbot",
          "title": "Onboarding Link"
        },
        "pre_employment_chat_assessment_url": {
          "description": "Personalized link to SHL Chat assessment",
          "title": "SHL Pre Employment Chat Assessment URL"
        },
        "reapply_retention_period": {
          "description": "Campaign's cooling period",
          "title": "Re-apply Retention Period"
        },
        "recruiter_first_name": {
          "description": "First name of the assigned recruiter",
          "title": "Assigned Recruiter First Name"
        },
        "referee": {
          "description": "Name of the person who referred a candidate",
          "title": "Referree"
        },
        "rejected_reasons": {
          "description": "Reasons for rejecting the candidate",
          "title": "Rejection Reasons"
        },
        "scheduled_at": {
          "description": "Candidate's scheduled date of interview",
          "title": "Scheduled at"
        },
        "scheduler_url": {
          "description": "Link to the campaign's recruitment center scheduler",
          "title": "Scheduler Link"
        },
        "shortlisted_reasons": {
          "description": "Reasons for shortlisting the candidate",
          "title": "Shortlisted Reasons"
        },
        "site_location": {
          "description": "Company site or branch where new hire will be assigned or trained",
          "title": "Site Location"
        },
        "svar_spoken_english_assessment_url": {
          "description": "Personalized link to SVAR Spoken English assessment",
          "title": "SVAR Spoken English Assessment URL"
        },
        "training_batch": {
          "description": "Batch or wave of trainees for onboarding",
          "title": "Training Batch"
        },
        "training_date": {
          "description": "Date of training as part of onboarding",
          "title": "Training Date"
        },
        "training_program": {
          "description": "Class or program of training for onboarding",
          "title": "Training Program"
        },
        "training_time": {
          "description": "Time of onboarding training",
          "title": "Training Time"
        },
        "training_venue": {
          "description": "Place of onboarding training",
          "title": "Training Venue"
        },
        "upcoming_scheduled_appointment": {
          "description": "Candidate's upcoming scheduled date of interview",
          "title": "Upcoming Scheduled Appointment"
        },
        "whatsapp_call_to_action_link": {
          "description": "Whatsapp To Action Link",
          "title": "Whatsapp Call To Action Link"
        },
        "workday_candidate_id": {
          "description": "Candidate ID from Workday",
          "title": "Workday Candidate ID"
        }
      }
    },
    "prompt": {
      "label": {
        "add_a_question": "Add a Question",
        "create_new": "Create New",
        "delete": "Delete",
        "question_set": {
          "name": "Question Set Name",
          "search": "Search Question Sets",
          "send": "Send Question Set"
        }
      },
      "text": {
        "created_by": "Created by %{name} on %{date}",
        "edited_by": "Edited by %{name} on %{date}",
        "question_set": {
          "cannot_be_deleted": "This Question Set cannot be deleted as it's being used by Autoflow in the following campaigns",
          "description": "Configure sets of questions from Question Templates to be used in Autoflow to trigger Follow up Question to Leads at any point of the process. ",
          "name_description": "This name will help you identify your Question Set when configuring an Autoflow. We recommend that you make it unique and easy to identify.",
          "title": "Question Sets",
          "used_in_campaigns": "This Question Set cannot be deleted as it's being used in the following Campaigns"
        }
      }
    }
  },
  "guests": {
    "interview": {
      "input": {
        "email": "Email",
        "first_name": "First Name",
        "last_name": "Last Name",
        "new_recording": "New Recording",
        "phone_number": "Phone Number",
        "record_now": "Record Now",
        "start_camera": "Start Camera",
        "stop_recording": "Stop Recording",
        "take_picture": "Take a picture"
      },
      "notes": {
        "video_limit": "The maximum video response length is 1 minute."
      },
      "show": {
        "about": "About"
      },
      "success": {
        "answers_message": "Thank you for submitting your responses. We have received your application.",
        "title": "Thank you"
      }
    }
  },
  "helpers": {
    "select": {
      "prompt": "Please select"
    },
    "submit": {
      "create": "Create %{model}",
      "submit": "Save %{model}",
      "update": "Update %{model}"
    }
  },
  "integration": {
    "facebook": {
      "add_image": "Add Image",
      "apply": "Apply",
      "change_image": "Change Image",
      "save": "Save",
      "select_page_helper": "Linking Facebook page(s) means anyone who chats to your bot can see this campaign. For this campaign not to appear on the chatbot, leave this field empty.\nBelow you can see all the messenger interview links to direct candidates directly to the chatbot interview, this is available even if the facebook page is not linked to this campaign (indicated by the lock icon).",
      "view_job_description": "View Job Description"
    },
    "google": {
      "google_job": "Google Jobs (beta)",
      "job_par": {
        "best_practice": "best_practices",
        "first": "Jobs that are listed on Google will appear directly in the Google search results.",
        "head": "Enable Google indexing of the Landing Page",
        "help_center": "our help center",
        "second": "Applicants that click on these job listings are forwarded to the Talkpush Job Landing Page, where they can choose to apply and immediately complete the screening questions. You can learn more about it in",
        "third": "If your job does not appear in the Google Job posting please make sure you are following those"
      }
    },
    "indeed": {
      "paragraphs": {
        "par_3": "Requires job title, country, region, and long description to be filled out."
      }
    },
    "landing": {
      "copy": "Copy",
      "first": "Landing Page URL",
      "save": "Save"
    },
    "tecoloco": {
      "job_par": {
        "first": "Jobs that are listed in Tecoloco will appear in the Tecoloco feed.",
        "head": "Advertise the job opening on Tecoloco Jobs",
        "help_center": "our help center",
        "second": "Candidates who apply to these job listings are forwarded to the Talkpush Job Landing Page, where they can apply and immediately complete the screening questions. You can learn more about it in"
      },
      "tecoloco_jobs": "Tecoloco Jobs"
    }
  },
  "job_landing_page": {
    "application_invalid": "Invalid application"
  },
  "jobs": {
    "salary_types": {
      "annually": "Annually",
      "biweekly": "Biweekly",
      "daily": "Daily",
      "hourly": "Hourly",
      "monthly": "Monthly",
      "one-time": "One-time",
      "weekly": "Weekly"
    }
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ",",
        "format": "%u%n",
        "precision": 2,
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "$"
      }
    },
    "format": {
      "delimiter": ",",
      "precision": 3,
      "round_mode": "default",
      "separator": ".",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "Billion",
          "million": "Million",
          "quadrillion": "Quadrillion",
          "thousand": "Thousand",
          "trillion": "Trillion",
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "privacy_policy_url": "https://talkpush.com/privacy/",
  "setup_questions": {
    "onboarding_title": "Onboarding Questions",
    "question_types": {
      "audio": "Audio",
      "text": "Text"
    },
    "update": "Update"
  },
  "time": {
    "am": "AM",
    "formats": {
      "date": "%b %d, %Y",
      "datemonth": "%d %b",
      "datemonthyear": "%d %b %Y",
      "datemonthyeartime": "%d %b %Y %I:%M %p",
      "datetime": "%b %d, %Y %I:%M %p",
      "default": "%a, %d %b %Y %H:%M:%S %z",
      "long": "%B %d, %Y %H:%M",
      "short": "%d %b %H:%M",
      "timedate": "%I:%M %p %d %b, %Y"
    },
    "minute": "1 minute",
    "minutes": "%{minutes} minutes",
    "pm": "PM",
    "second": "1 second",
    "seconds": "%{seconds} seconds",
    "time_left": "Time Left: %{minutes} %{seconds}"
  }
});

window.t = I18n.t.bind(I18n);
window.l = I18n.l.bind(I18n);
I18n.locale = document.documentElement.lang;
